import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { createMessageDialogSlice } from './actions';
import { MessageDialogStore } from './types';
import { ZustandStores } from '../utils';
import { createIndexedDBStorage } from '../utils/indexedDBAdapter';

export const useMessageDialogStore = create<MessageDialogStore>()(
  persist(
    (set, get, store) => ({
      ...createMessageDialogSlice(set, get, store),
    }),
    {
      name: ZustandStores.MESSAGE_DIALOG,
      storage: createJSONStorage(() => createIndexedDBStorage()),
      partialize: (state) => ({
        isNewMessageExpanded: state.isNewMessageExpanded,
      }),
    },
  ),
);
